import { Theme, styled } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOutdated: boolean;
  noResultsFound: boolean;
  newResults: boolean;
};

const FeedbackMessage = styled('div')<Theme>(({ theme }) => ({
  fontSize: theme.typography.h4.fontSize,
  color: theme.palette.grey['700'],
  position: 'absolute',
  bottom: '-3rem',
  right: '7rem',
  fontStyle: 'italic',
}));

const FilterFeedback: FC<Props> = ({ isOutdated, noResultsFound, newResults }) => {
  const { t } = useTranslation();

  return (
    <>
      {isOutdated ? (
        <FeedbackMessage>{t('shared.progressScoresOutdated')}</FeedbackMessage>
      ) : (
        <>
          {noResultsFound ? (
            <FeedbackMessage>{t('shared.progressScoresNoResults')}</FeedbackMessage>
          ) : (
            newResults && <FeedbackMessage>{t('shared.progressScoresNewResults')}</FeedbackMessage>
          )}
        </>
      )}
    </>
  );
};

export default FilterFeedback;
